import * as moment from 'moment';
import { Moment } from 'moment';

export class DateTimeHelper {

  private static _lang = localStorage.getItem('lang') || 'fr';
  private static _datetime: any = new Date(2018, 10, 10, 12, 10, 0);
  private static _date = DateTimeHelper._datetime.getDate();
  private static _month = DateTimeHelper._datetime.getMonth() + 1;
  private static _year = DateTimeHelper._datetime.getFullYear();
  private static _pattern: string = new Intl.DateTimeFormat(DateTimeHelper._lang).format(DateTimeHelper._datetime);

  public static get dateTimeFormat(): string {
    return DateTimeHelper._pattern
      .replace(DateTimeHelper._date, 'DD')
      .replace(DateTimeHelper._month, 'MM')
      .replace(DateTimeHelper._year, 'YYYY')
  }
  public static getDateTimeFormatByLocale(locale: string = 'fr') {
    return new Intl.DateTimeFormat(locale).format(DateTimeHelper._datetime)
      .replace(DateTimeHelper._date, 'DD')
      .replace(DateTimeHelper._month, 'MM')
      .replace(DateTimeHelper._year, 'YYYY')
  }


  public static parseMoment(date: Moment) {
    return date ? date.format(DateTimeHelper.dateTimeFormat) : null;
  }
  public static parseMomentByFormat(moment: Moment, format: string) {
    return moment.format(format)
  }
  public static parseDate(date: any): string {
    if (date) {
      return new Intl.DateTimeFormat(DateTimeHelper._lang).format(new Date(date))
    }
    return null;
  }
  public static parseDateWithoutTimezone(date: any): string {
    if (date) {
      return moment(date).format(DateTimeHelper.getDateTimeFormatByLocale());
    }
    return null;
  }
  public static parseDateTime(date: any): string {
    if (date)
      return (new Date(date)).toLocaleString(DateTimeHelper._lang)
    return null;
  }
  public static parseDateTimeCalendarUTC(date: any): string {
    // moment.utc => Diplay value at UTC +00
    if (date)
      moment.locale(this._lang)
      return moment.utc(date).calendar()
      // return (new Date(date)).toLocaleString(DateTimeHelper._lang)
    return null;
  }
  public static parseDateTimeCalendar(date: any): string {
    // moment.utc => Diplay value at UTC +00
    moment.locale(this._lang)
    if (date)
      return moment(date).calendar()
    return null;
  }
  public static parseISODate(date: any): string {
    if (date)
      return new Date(date).toISOString().substring(0, 10);
    return date;
  }
  public static parseTime(date: any) {
    return moment.utc(date).format('HH:mm')
  }
  public static parseTimeWithoutUtc(date: any) {
    return moment(date).format('HH:mm')
  }
  public static parseLongDate(date: any) {
    return moment.utc(date).format('DD MMMM YYYY')
  }
  public static parseLongDateWithouUtc(date: any, lang?: string) {
    moment.locale(lang || 'fr')
    return moment(date).format('DD MMM YYYY')
  }
  public static parseDateByFormat(date: string | Date, format: string) {
    return moment(date).format(format)
  }
  public static mergeDateTime(date: string, time?: string) {
    if (time && date)
      return `${date}T${time}:00`;
    else if (date)
      return date;
    return '';
  }

  public static removeTimezone(datetime: string) {
    if (datetime)
      return datetime.replace('T', ' ').replace('Z', ' ');
    else throw Error('Datetime is undefined');
  }
  public static parseToUtc(datetime: string) {
    const format: string = moment(datetime).format('YYYY-MM-DDTHH:mm:ss');
    return datetime.match('.000Z') ? format : `${format.replace('Z', '')}.000Z`;
  }

  public static roundMinute(mom = moment()): moment.Moment {
    let minute = mom.get('m');
    let mDiff = 0;
    const result = minute / 5;

    if (result - Math.trunc(result) !== 0) {
      const unit = parseInt(minute.toString().substr(1));

      if (unit > 5) {
        mDiff = 10 - unit
      } else {
        mDiff = 5 - unit
      }
      mom = mom.add(mDiff, 'm')
    }

    return mom;
  }

  public static roundMinuteByStep(startMoment: moment.Moment, step: number, format: string = "YYYY-MM-DDTHH:mm:ss") {

    const currentMinutes = startMoment.get("m");
    const diff = currentMinutes - step;
    let start_date: Moment, end_date: Moment;
    let formatted_start_dated: string, formatted_end_dated: string;

    if (diff < 0) {
      start_date = startMoment.add(Math.abs(diff), 'm');
    } else {
      const mDiff = step - diff
      start_date = startMoment.add(mDiff, 'm');
    }
    formatted_start_dated = start_date.format(format);

    end_date = start_date.add(step, 'm');
    formatted_end_dated = end_date.format(format);


    return {
      start_date: formatted_start_dated,
      end_date: formatted_end_dated,
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/DateTimeHelper.util.ts